export default __webpack_public_path__ + "static/media/oa_5.765df9bf.mp3";